export default "__VITE_ASSET__DD741wYu__"